// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "primeui." + {"163":"4d8528f437e36c906c01","241":"c67c8800715bab62e38b","306":"c0ca10e4a80235de8d0e","466":"46713e76bb826d0d7ff3","620":"5159dc4024049c73f035","646":"1e195e1626735ed65ddf","721":"23189616759ac1141937","726":"ffc23368c31acf3c8030","755":"6f8330c4f3a47342b59c"}[chunkId] + ".css";
};